import React, { useContext } from "react";
import { ThemeContext } from "../../context/Theme/ThemeContext";
import "../../css/pages/SalesFunnel/SalesFunnelHeader.css";
import { SalesFunnelSwitcher } from "../../components/SalesFunnelSwitcher";

export default function SalesFunnelHeader({ valores, onAddColumn }) {

	const { darkMode } = useContext(ThemeContext);

	const changeTitle = async(name) => {
		const title = document.getElementById("sale-funnel-title");
		title.innerText = "Funil de Vendas - " + name;
	}

	const ShowSaleFunnel = async (visivel) => {
		const switcher = document.getElementById("switcher-sale-funnel");
		switcher.style.display = visivel ? "block" : "none";
	}

	const totalValorFormatado = Number(String(valores.totalValor).replace(",", ".")).toFixed(2);
	const labelLeads = valores.totalContacts !== 1 ? "Leads" : "Lead";

	const themeClass = darkMode ? "sf-header--dark" : "sf-header--light";

	return (
		<header className={`sf-header ${themeClass}`}>
			<div className="sf-header__inner">
				<div className="sf-header__row">
					<div className="sf-header__title-block">
						<div className="sf-header__title-block">
							<h1 id="sale-funnel-title" className="sf-header__title">Funil de Vendas</h1>
						</div>
					</div>

					<div className="sf-header__actions">
						<div className="sf-header__stats">
							<span className="sf-header__badge">
								{valores.totalContacts} {labelLeads}
							</span>
							<div className="sf-header__valor">
								<span className="sf-header__valor-symbol">R$</span>
								<span className="sf-header__valor-number">{totalValorFormatado}</span>
							</div>
						</div>
						<div className="sf-header__buttons">
							<div className="sf-header__link-wrapper">
								<span className="sf-header__link sf-header__link--disabled" aria-disabled="true">
									<svg className="sf-header__link-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden>
										<path strokeLinecap="round" strokeLinejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z" />
										<path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
									</svg>
									Automatize
								</span>
								<span className="sf-header__badge-soon">Em breve</span>
							</div>
							{/* <button type="button" onClick={() => onAddColumn()} className="sf-header__btn">
								<svg className="sf-header__btn-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden>
									<path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
								</svg>
								Adicionar coluna
							</button> */}
							<div
								onMouseLeave={() => ShowSaleFunnel(false)}
							>
								<button className="sf-header__btn" onClick={() => ShowSaleFunnel(true)}>
									<svg class="size-4 text-default-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
										<polyline points="6 9 12 15 18 9"></polyline>
									</svg>
									Funil de vendas
								</button>
								<div
									id="switcher-sale-funnel"
									className="bg-black-600 rounded-xl"
									style={{
										position: "absolute", 
										minWidth: "250px", 
										zIndex: 999, 
										paddingTop: "15px", 
										display: "none",
										transform: "translateX(-24%)"
									}}
								>
									<SalesFunnelSwitcher
										style={{ width: '100%'}}
										onChange={changeTitle}
										OnCreateNewFunnel={()=>ShowSaleFunnel(false)}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>
	);
}
